import { ICompTypes } from "../features/Comp/interfaces";
import { routes } from "config/routes";
import { ReactComponent as CompanyGroups } from "assets/svg/companyGroup.svg";
import { ReactComponent as Properties } from "assets/svg/properties.svg";
import { ReactComponent as MarketAreas } from "assets/svg/marketAreas.svg";
import { ReactComponent as Settings } from "assets/svg/settings.svg";
import { ReactComponent as MyDeals } from "assets/svg/bookmark.svg";
import { ReactComponent as PortfolioDashboardIcon } from "assets/svg/portfolioDashboard.svg";
import { ReactComponent as Templates } from "assets/svg/templateIcon.svg";
import { ReactComponent as ChatAppIcon } from "assets/svg/ChatAppIcon.svg";
import { ReactComponent as ResearchIcon } from "assets/svg/researchFlow.svg";
import { templatesTranslations } from "../pages/Templates/translations";
import { ResearchStaffLevelEnum } from "features/Research/types";

export const appVersion = "1";

export const SIDEBAR_CONFIG = [
  {
    id: 1,
    title: "Company Groups",
    route: routes.private.companyGroups,
    Icon: CompanyGroups,
  },
  {
    id: 2,
    title: "Properties",
    route: routes.private.properties,
    Icon: Properties,
  },
  {
    id: 3,
    title: "My Deals",
    route: routes.private.myDeals,
    Icon: MyDeals,
  },
  {
    id: 4,
    title: "WIP Tracker",
    route: routes.private.research,
    Icon: ResearchIcon,
  },
  {
    id: 5,
    title: "Portfolio Dashboard",
    route: routes.private.portfolioDashboard,
    Icon: PortfolioDashboardIcon,
  },
  {
    id: 6,
    title: "Market Areas",
    route: routes.private.marketAreas,
    Icon: MarketAreas,
  },
  {
    id: 7,
    title: templatesTranslations.templates,
    route: routes.private.templates,
    Icon: Templates,
  },
  {
    id: 8,
    title: "Settings",
    route: routes.private.settings,
    Icon: Settings,
  },
  {
    id: 9,
    title: "Assistant Settings",
    route: routes.private.assistantPages,
    Icon: ChatAppIcon,
  },
];

export const subscriptionColorConfig: {
  [key: string]: string;
} = {
  PRO: "#E1A34B",
  TEAM: "#67B75A",
  BASIC: "#D3D3D3",
};

export const COLLAPSED_ROUTES = [
  routes.private.properties,
  routes.private.viewProperties,
  routes.private.viewSaleComp,
  routes.private.viewRentComp,
  routes.private.viewExpenseComp,
  routes.private.mergeSaleComp,
  routes.private.mergeRentComp,
  routes.private.mergeExpenseComp,
  routes.private.newProperty,
];

export const titleStyles = {
  fontSize: "12px",
  fontWeight: "600",
};
export const valueStyles = {
  fontSize: "16px",
  fontWeight: "300",
};

export const SUBSCRIPTION_TYPES = {
  PRO: "PRO",
  TEAM: "TEAM",
  BASIC: "BASIC",
};

const ADMIN = "ADMIN";
const RESEARCHER = "RESEARCHER";
const REVIEWER_MANAGER = "REVIEWER_MANAGER";

export const isAdmin = (roles: string[]) => {
  return roles.includes(ADMIN);
};

export const isResearchManager = (
  roles: string[],
  researchStaffLevel?: ResearchStaffLevelEnum | null,
  researchStaffEligible = false
) =>
  isAdmin(roles) ||
  (researchStaffEligible &&
    (roles.includes(REVIEWER_MANAGER) ||
      researchStaffLevel === ResearchStaffLevelEnum.REVIEWER_MANAGER));

export const isResearchStaff = (
  roles: string[],
  researchStaffLevel?: ResearchStaffLevelEnum | null,
  researchStaffEligible = false
) =>
  isResearchManager(roles, researchStaffLevel, researchStaffEligible) ||
  (researchStaffEligible &&
    (roles.includes(RESEARCHER) ||
      researchStaffLevel === ResearchStaffLevelEnum.RESEARCHER));

export const forbiddenMemberRoutes = [
  routes.private.companyGroups,
  routes.private.viewCompanyGroup,
  routes.private.viewUser,
];

export const coinsValue = 1;
export const disabledAccountError = "Your SeniorComps account was disabled.";
export const deletedAccountError = "Your SeniorComps account was deleted.";
export const phonePrefix = "+1";
export const submitKey = "Enter";
export const removeKey = "removeOption";
export const percentMultiplicator = 100;
export const timezoneUTC = "UTC";
export const seniorType = "senior";
export const blockedStatus = "blocked";
export const logoutEvent = "logout";
export const broadcastLogoutChannel = "logout-channel";

export const maxIndex = 2;
export const slashKey = "/";
export const COMP_TYPES: { [key: string]: ICompTypes } = {
  sale: "sale",
  rent: "rent",
  expense: "expense",
};
export const zeroWidthSpace = "\u200b";
export const nonBreakingSpace = "\u00A0";
export const blackCircle = "\u25CF";
export const newline = "\n";
export const landingWidth = "1440px";
export const GOOGLE_ANALYTICS_ID = "G-LNRPZDCTGX";
export const AUTO_FILL_EVENT_NAME = "mui-auto-fill";
export const AUTO_FILL_CANCEL_EVENT_NAME = "mui-auto-fill-cancel";

export const SORT_DIRECTION: { [key: string]: "asc" | "desc" } = {
  asc: "asc",
  desc: "desc",
};

export enum SORT_DIRECTIONS_ENUM {
  ASC = "asc",
  DESC = "desc",
}

export const DEFAULT_PROPERTY_ZOOM_LEVEL = 17;
export const MIDDLE_CLICK_KEY = 1;
export const LEFT_CLICK_KEY = 0;
export const GOOGLE_MAPS_API_VERSION = "3.64";
